export default theme => ({
  container: {
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    left: 0,
    bottom: 0,
    height: theme.spacing(7),
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 100%)',
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
  },
  overlay: {
    zIndex: '90 !important',
  },
  item: {
    position: 'relative',
  },
  tooltip: {
    textAlign: 'center',
  },
  itemMenu: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    width: theme.spacing(20),
    left: '50%',
    bottom: '100%',
    transform: 'translateX(-50%)',
    pointerEvents: 'none',
    alignItems: 'center',
    opacity: 0,
    transition: 'opacity 0s',
  },
  itemMenuActive: {
    pointerEvents: 'all',
    opacity: 1,
    transition: 'opacity 0.5s',
  },
  itemMenuTitle: {
    textTransform: 'none',
  },
  icon: {
    color: theme.palette.white.main,
  },
  menuButton: {
    position: 'relative',
    '&:before': {
      position: 'absolute',
      content: '""',
      height: 30,
      width: 2,
      left: 'calc(50% - 1px)',
      top: 33,
      backgroundColor: theme.palette.white.main,
    },
  },
  checked: {
    '& > span:first-child': {
      borderRadius: '100%',
      backgroundColor: theme.palette.white.main,
    },
  },
  itemButton: {
    marginBottom: theme.spacing(1),
  },
  subButton: {
    marginBottom: theme.spacing(2),
  },
  lineContainer: {
    position: 'absolute',
    top: 'calc(50% - 1px)',
    height: 2,
    width: `calc(100% - ${theme.spacing(20) - 4}px)`,
    left: theme.spacing(10) - 2,
    '&:before': {
      content: '""',
      position: 'absolute',
      height: '100%',
      width: theme.spacing(10),
      left: -theme.spacing(10),
      top: 0,
      backgroundColor: theme.palette.white.main,
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      height: '100%',
      width: theme.spacing(10),
      right: -theme.spacing(10),
      top: 0,
      backgroundColor: theme.palette.white.main,
    },
  },
  line: {
    height: '100%',
    backgroundColor: theme.palette.white.main,
    top: 0,
    position: 'absolute',
  },
});
